import { Asset } from "../models/asset";
import { ITruckerPayPlanData } from "../models/truckerPayPlan";

import ApiService from "../services/api";

export const fetchContractDetails = async (
  asset: Asset,
): Promise<ITruckerPayPlanData> => {
  const apiService = new ApiService();

  const params = new URLSearchParams();
  if (asset.odometer > 0) params.append("odometer", String(asset.odometer));
  if (asset.hourmeter > 0) params.append("hourMeter", String(asset.hourmeter));

  const response = await apiService.get<ITruckerPayPlanData>(
    `/assets/${asset.chassis}/trucker-pay-plan?${params.toString()}`,
  );
  if (response.status !== 200 || !response.data) {
    throw new Error("Erro ao buscar detalhes do contrato");
  }
  return response.data;
};
